export default "__VITE_ASSET__RH6tSOCj__"